import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { DEFAULT_THEME, DEFAULT_PADDING_HEADER } from '../config';
import { Context } from '../context';
import type { TMainBannerDesktop } from '../models';

export const MainBannerDesktop: FC<React.PropsWithChildren<TMainBannerDesktop>> = ({
    Block,
    Grid,
    Layout,
    className,
    children,
    dataTestId,
    minHeight,
    styles,
    theme = DEFAULT_THEME,
    titlePaddingTop = DEFAULT_PADDING_HEADER,
    useNamedContainers,
    verticalAlignment,
}) => {
    const {
        bottomAdditionalContentSlot,
        breadcrumbsSlot,
        headerSlot,
        imageSlot,
        subMenuSlot,
        subTitleSlot,
        titleSlot,
        underSubtitleSlot,
    } = useNamedContainers(children);

    // Отступ сверху при использовании <MainHeader />
    const headerGap = headerSlot && (breadcrumbsSlot || subMenuSlot);

    return (
        <Context.Provider value={{ theme }}>
            <div className={className} data-test-id={dataTestId}>
                {headerSlot && (
                    <div className={cn({ [styles.headerGap]: headerGap })}>{headerSlot}</div>
                )}

                <Layout>
                    <Grid
                        alignment={verticalAlignment}
                        collapse
                        columnsWidth={[null, '564px']}
                        justify="center"
                    >
                        <div style={{ minHeight }}>
                            {breadcrumbsSlot && (
                                <div
                                    className={cn(styles.breadcrumbsWrapper, {
                                        [styles.breadcrumbsGap]: headerGap,
                                    })}
                                >
                                    {breadcrumbsSlot}
                                </div>
                            )}
                            <Block notPadded style={{ paddingTop: titlePaddingTop }}>
                                {titleSlot}
                                {subTitleSlot}
                                {underSubtitleSlot}
                            </Block>
                        </div>

                        <>
                            {subMenuSlot}
                            {imageSlot}
                        </>
                    </Grid>
                    {bottomAdditionalContentSlot && (
                        <div className={styles.bottomAdditionalContentGap}>
                            {bottomAdditionalContentSlot}
                        </div>
                    )}
                </Layout>
            </div>
        </Context.Provider>
    );
};
